import { Outlet, useLocation } from "react-router-dom";
import Header from "./header/Header";
import ScrollToTop from "./header/scrollToTop";

function Layout() {
  const location = useLocation();
  const hideHeader = location.pathname.startsWith("/hrms-implement");

  return (
    <>
      {!hideHeader && <Header />}
      {!hideHeader && <ScrollToTop />}
      <Outlet />
    </>
  );
}

export default Layout;
